module.exports = __webpack_public_path__ + "img/11_of_Spades.svg.6054aaa9.png";